import React, { FC, useEffect } from "react";
import Filters from "@components/Filters/Filters";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import LabelFilters from "@components/PhotoFilters/LabelFilters";
import { PhotoSearchFilters } from "@store/photoApi";
import PeopleFilters from "@components/PhotoFilters/PeopleFilters";
import { useGetAlbumFiltersQuery } from "@store/albumApi";
import Loader from "@components/Loader/Loader";
import DateFilters from "@components/PhotoFilters/DateFilters";
import { UseFormReturn } from "react-hook-form";

const Section = styled.div`
  margin-bottom: 32px;
`;

const PhotoFilters: FC<{
  patientId: string;
  albumId?: string;
  form: UseFormReturn<PhotoSearchFilters>;
}> = ({ patientId, form, albumId }) => {
  const { t } = useTranslation();

  const { data, isLoading } = useGetAlbumFiltersQuery(
    { albumId: albumId || "" },
    { skip: !albumId },
  );

  useEffect(() => {
    if (!data) {
      return;
    }
    form.reset(data);
  }, [data, form]);

  return (
    <Filters title={t("albums.addPhotosDialog.filters.title")}>
      {isLoading ? (
        <Loader />
      ) : (
        <form>
          <Section>
            <LabelFilters patientId={patientId} form={form} />
          </Section>

          <Section>
            <PeopleFilters patientId={patientId} form={form} />
          </Section>

          <Section>
            <DateFilters form={form} />
          </Section>
        </form>
      )}
    </Filters>
  );
};

export default PhotoFilters;
